import _ from "lodash";
import React, { useContext } from "react";
import { ProjectPlannerContext } from "Projects/modules/ProjectModules";
import labelClasses from "UnitPlans/components/LabelComponent/LabelComponent.scss";
import { IconButton, useDSContext } from "@toddle-edu/ds-web";
import { HelpBulbOutlined } from "@toddle-edu/ds-icons";

//Only inside Projects!
const HelpButton = ({ uid, details, size, testId = "appComponent" }) => {
  let helpButtonDetails = useContext(ProjectPlannerContext);

  const { dsVersion } = useDSContext();

  //For components that don't belong to ProjectPlannerContext
  if (_.isEmpty(helpButtonDetails)) {
    helpButtonDetails = details;
  }

  const {
    onHelpClick,
    currentRightPane,
    currentFieldId,
    template,
  } = helpButtonDetails;

  const helpEnabledFields = template?.helpEnabledFields;
  const helpText = _.find(helpEnabledFields, { uid });

  const isHelpActive =
    currentRightPane === "help" && currentFieldId == helpText?.id;

  const onClickHelp = () => {
    onHelpClick({
      fieldKey: uid,
      helperTextId: _.get(helpText, "helpText.id", null),
      id: helpText?.id,
    });
  };
  return helpText ? (
    <div className={labelClasses.labelHelper}>
      <IconButton
        icon={
          <HelpBulbOutlined variant={dsVersion === "2.0" ? "subtle" : ""} />
        }
        _legacy_variant="plain"
        type="plain"
        variant="neutral"
        isActivated={isHelpActive}
        size={size}
        onClick={onClickHelp}
        id={`help-button-${uid}`}
        testId={`${testId}-help`}
      />
    </div>
  ) : null;
};

HelpButton.defaultProps = {
  size: "medium",
};

export default HelpButton;
